export let feedbackPanelCloseButtonAriaLabel = "ITE2Ce";
export default {feedbackPanelCloseButtonAriaLabel};